module.exports = __webpack_public_path__ + "img/Marquise vue 2.e92f9a5a.jpg";